<template>
  <transition name="modal">
    <div class>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <!-- <div class="modal-header">
          <slot name="header"></slot>
          </div>-->

          <div class="modal-body">
            <slot name="body"></slot>
          </div>

          <!-- <div class="modal-footer">
          <slot name="footer"></slot>
          </div>-->
        </div>
      </div>
      <div id="closepopup" class="modal modal-mask" style="display: block" @click="close()"></div>
    </div>
  </transition>
</template>



<script>
export default {
  name: "Modal",
  data() {
    return {
      showModal: false
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("closeModal");
      var x = document.getElementById("closepopup");
      if (x.style.display === "none") {
        x.style.display = "block";
      } else {
        x.style.display = "none";
      }
      var body = document.body;
      body.style.position = "initial";
      body.style.width = "auto";
    }
  },
  computed: {}
};
</script>

<style>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-dialog {
  min-width: 40rem;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 11;
}
.modal-content {
  border: none;
  box-shadow: none;
}
@media only screen and (max-width: 767px) {
  .modal-content {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue